export const BANQUET_SHIFT = "Banquet Shift";
export const BANQUET_FUNCTION = "Banquet Function";
export const CORPORATE_MEAL = "Corporate Meal";
export const BANQUET_BUFFET_TYPE = "Banquet Buffet Type";
export const BANQUET_DECORATION = "Banquet Decoration";
export const BANQUET_DJ = "Banquet Dj Booking";
export const ESTIMATED_ADULTS = "Estimated Adults";
export const ACTUAL_ADULTS = "Actual Adults";
export const BILLNUMBERNAME = "Prefix Name For Your Bill";
export const INVOICE_COUNT_ENABLE = "Invoice Count Enable";
export const SMS_REQUEST_COUNT = "SMS Request count";
export const AADHAR_REQUEST_COUNT = "Aadhar Request count";
export const DRIVING_LICENSE_REQUEST_COUNT = "Driving Request count";


export const BANKTRANSACTIONID = "bank_transactionId";
export const PG_SIGNATURE = "pg_signature";
export const PAYMENT_GATEWAY_TRANSACTIONID = "pg_transactionId";
export const ORDER_FROM_ID = "Order_From_Id";
export const ORDER_FROM = "Order_From";
export const ACTUAL_CHECK_IN = "Actual_Check_In";


export const CHECKIN_TIME_DEFINE = "CheckIn Time";
export const CGST = "CGST";
export const SGST = "SGST";